import SECONDARY_COLORS from '../colors/secondary.js';
import SECONDARY_BORDER_RADIUS from '../borderRadius/secondary.js';
import SECONDARY_BOX_SHADOWS from '../boxShadows/secondary.js';
import SECONDARY_FONTS from '../fonts/secondary.js';
import { SECONDARY_TYPOGRAPHY } from '../typography/secondary.js';

var secondaryTheme = {
  __type: 'secondary',
  BORDER_RADIUS: SECONDARY_BORDER_RADIUS,
  BOX_SHADOWS: SECONDARY_BOX_SHADOWS,
  COLORS: SECONDARY_COLORS,
  FONTS: SECONDARY_FONTS,
  TYPOGRAPHY: SECONDARY_TYPOGRAPHY
};

export { secondaryTheme };
